<footer class="dash-footer text-white p-3 mt-auto">
  <div class="logo-footer">
    <div class="logo">
      <img (click)="routeToHome()" src="assets/Images/Logo-img.png" alt="Bahamas Logo" class="logo-img" loading="lazy" />
    </div>

    <div class="info">
      <div class="info-col">
        <p class="footer-heading" (click)="toggleSection('contact')">CONTACT US

          <i *ngIf="isMobileView" class="bi" [ngClass]="{
              'bi-chevron-up': openSection.has('contact'),
              'bi-chevron-down': !openSection.has('contact')
            }"></i>

        </p>
        <ul class="inner-links" *ngIf="!isMobileView || openSection.has('contact')">
          <li><a (click)="routeToPage('about-us')" class="textHover"><span class="link-text">About Us</span></a></li>
          <li><a (click)="routeToPage('/help/contact-information')" class="textHover"><span class="link-text">Contact
                Information</span></a></li>
          <!-- <li><a href="/about-mof/careers" class="textHover"><span class="link-text">Careers</span></a></li> -->
        </ul>
      </div>

      <!-- <div class="info-col">
        <p class="footer-heading" (click)="toggleSection('quick-links')">USEFUL RESOURCES
          <i *ngIf="isMobileView" class="bi" [ngClass]="{
              'bi-chevron-up': openSection.has('quick-links'),
              'bi-chevron-down': !openSection.has('quick-links')
            }"></i>

        </p>
        <ul class="inner-links" *ngIf="!isMobileView || openSection.has('quick-links')">
          <li><a href="#" class="textHover" title="Subscribe to e-alerts"><span class="link-text">Subscribe to
                e&#8209;alerts</span></a></li>
          <li><a href="#" class="textHover" title="Report Vulnerability"><span class="link-text">Report
                Vulnerability</span></a></li>
        </ul>
      </div> -->

      <div class="info-col">
        <p class="footer-heading" (click)="toggleSection('follow-us')">FOLLOW US
          <i *ngIf="isMobileView" class="bi" [ngClass]="{
              'bi-chevron-up': openSection.has('follow-us'),
              'bi-chevron-down': !openSection.has('follow-us')
            }"></i>
        </p>
        <ul class="inner-links" *ngIf="!isMobileView || openSection.has('follow-us')">
          <li><a href="https://www.facebook.com/vatbah242/?notif_t=page_name_change" target="_blank"
              class="textHover"><i class="bi bi-facebook" title="Facebook"></i><span
                class="link-text">Facebook</span></a></li>
          <li><a href="https://twitter.com/IRevenue242" target="_blank" class="textHover"><i
                class="bi bi-twitter-x"></i><span class="link-text" title="Twitter">X</span></a></li>
          <li><a href="https://www.youtube.com/channel/UC1T8aANuM8okw_tYLmwNFIA" target="_blank" class="textHover"><i
                class="bi bi-youtube" title="Youtube"></i><span class="link-text">Youtube</span></a></li>
          <!-- <li><a href="" class="textHover" target="_blank" title="Instagram"><i class="bi bi-instagram"></i><span
                class="link-text">Instagram</span></a> 
          </li>-->
        </ul>
      </div>
    </div>
  </div>

  <!-- <div class="cpDisclaimer">
    <h1>Disclaimer</h1>
    <p>The content on this website is provided for informational and testing purposes only. Please note the following:
    </p>

    <ol>
      <li>The content presented is still in draft form and may be incomplete, subject to change or contain errors. At
        this stage, it is not intended to serve as official documentation or guidance.</li>
      <li>All content is pending final review and approval by the Transformation Management Office (TMO). Any
        statements, processes or references should be considered preliminary until officially approved by the TMO.</li>
      <li>Certain content is also pending review and formal sign-off by the Department of Inland Revenue (DIR). Until
        approval is confirmed, the information should not be relied upon for decision-making or operational purposes.
      </li>
    </ol>
    <p>By using this site, you acknowledge that the content is provisional and may be updated, revised or removed
      without notice. We recommend verifying any information with the appropriate authorities before making any
      decisions or taking action.</p>
  </div> -->

  <div class="cpFooter">
    <div class="docs">
      <ul class="docs-links">
        <li><a (click)="routeToPage('privacy-policy')" target="_self" class="textHover"><span class="link-texts">Privacy
              Policy</span></a></li>
        <li><a (click)="routeToPage('terms-of-use')" target="_self" class="textHover"><span class="link-texts">Terms of
              Use</span></a>
        </li>
        <li><a (click)="routeToPage('accessibility')" target="_self" class="textHover"><span
              class="link-texts">Accessibility</span></a>
        </li>
            <li *ngIf="loggedIn"><a (click)="routeToPage('site-map')" target="_self" class="textHover"><span
              class="link-texts">Sitemap</span></a></li>
        <!-- <li><a class="textHover"><span class="link-texts">Developer</span></a></li> -->
      </ul>
    </div>
    <div class="copyright">Copyright 2025 &copy; The Commonwealth of The Bahamas</div>
  </div>
</footer>